import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import {
  CLEAR_CABIN_CREW_TASK_SUMMARY,
  FLAG_GETTING_CABIN_CREW_TASK_SUMMARY_MONTHLY,
  FLAG_GETTING_CABIN_CREW_TASK_SUMMARY_MOVEMENTS,
  GET_CABIN_CREW_TASK_SUMMARY_MONTHLY,
  GET_CABIN_CREW_TASK_SUMMARY_MOVEMENTS,
} from '../types';
import { CABIN_CREW_TASK_SUMMARY_ENDPOINT } from '../../config/endpoints';
import { isErrorResponse } from '../../utils/error-handlers';
import { DEFAULT_GET_CONFIG } from '../../config/rest';

const flagGettingCabinCrewTaskSummaryMovements = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_CABIN_CREW_TASK_SUMMARY_MOVEMENTS,
    payload: flag,
  });

const flagGettingCabinCrewTaskSummaryMonthly = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_CABIN_CREW_TASK_SUMMARY_MONTHLY,
    payload: flag,
  });

const getCabinCrewTaskSummaryMovements = (query) => async (dispatch) => {
  try {
    dispatch(flagGettingCabinCrewTaskSummaryMovements(true));

    const url = `${CABIN_CREW_TASK_SUMMARY_ENDPOINT}/movements?${QueryString.stringify(
      query,
    )}`;

    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const movements = await response.json();

    dispatch({
      type: GET_CABIN_CREW_TASK_SUMMARY_MOVEMENTS,
      payload: movements,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingCabinCrewTaskSummaryMovements(false));
  }
};

const getCabinCrewTaskSummaryMonthly = (query) => async (dispatch) => {
  try {
    dispatch(flagGettingCabinCrewTaskSummaryMonthly(true));

    const url = `${CABIN_CREW_TASK_SUMMARY_ENDPOINT}/monthly?${QueryString.stringify(
      query,
    )}`;

    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const monthly = await response.json();

    dispatch({
      type: GET_CABIN_CREW_TASK_SUMMARY_MONTHLY,
      payload: monthly.content,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingCabinCrewTaskSummaryMonthly(false));
  }
};

const clearCabinCrewTaskSummary = () => (dispatch) =>
  dispatch({
    type: CLEAR_CABIN_CREW_TASK_SUMMARY,
  });

const exportCabinCrewTaskSummaryMonthly = (query) => async (dispatch) => {
  try {
    dispatch(flagGettingCabinCrewTaskSummaryMonthly(true));

    const url = `${CABIN_CREW_TASK_SUMMARY_ENDPOINT}/monthly/export?${QueryString.stringify(
      query,
    )}`;

    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);

    const blob = await response.blob();
    const downloadUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = 'resumen_tareo.xlsx';
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(downloadUrl);
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingCabinCrewTaskSummaryMonthly(false));
  }
};

export {
  flagGettingCabinCrewTaskSummaryMovements,
  flagGettingCabinCrewTaskSummaryMonthly,
  getCabinCrewTaskSummaryMovements,
  getCabinCrewTaskSummaryMonthly,
  clearCabinCrewTaskSummary,
  exportCabinCrewTaskSummaryMonthly,
};